const CheckOnly = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-check-only"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-check-only"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M7.8,21.425A2.542,2.542,0,0,1,6,20.679L.439,15.121,2.561,13,7.8,18.239,21.439,4.6l2.122,2.121L9.6,20.679A2.542,2.542,0,0,1,7.8,21.425Z" />
    </svg>
  );
};

export default CheckOnly;
